import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/utils/guards/auth.guard';
import { RoleGuard } from './shared/utils/guards/role.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'inicio',
    loadChildren: () =>
      import('./modules/inicio/inicio.module').then((m) => m.InicioModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'rutas',
    loadChildren: () =>
      import('./modules/rutas/rutas.module').then((m) => m.RutasModule),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['admin'] }, // solo admin
  },
  {
    path: 'solicitudes',
    loadChildren: () =>
      import('./modules/solicitudes/solicitudes.module').then(
        (m) => m.SolicitudesModule
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['admin', 'user'] }, // admin y user
  },
  {
    path: 'parametros',
    loadChildren: () =>
      import('./modules/parametros/parametros.module').then(
        (m) => m.ParametrosModule
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['admin'] },
  },
  {
    path: 'viajes',
    loadChildren: () =>
      import('./modules/viajes/viajes.module').then((m) => m.ViajesModule),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['admin', 'user'] },
  },
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  { path: '**', redirectTo: 'inicio' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
